// @context TGW-2591 「一言から作る」でタイトルを反映しても保存されず、リロードで戻っていた。
//   紹介文は20秒ごとに自動保存されるのにタイトルには自動保存が無く、
//   「古いタイトル＋新しい紹介文」というちぐはぐな状態になっていた。
//   components/axios は import 時に csrf-token メタタグを読むため jsdom では素通しできない。
jest.mock('../axios', () => ({ post: jest.fn() }));

// eslint-disable-next-line import/first
import axios from '../axios';
// eslint-disable-next-line import/first
import { saveTitle, fetchCoverImageUrl, watchCoverImage } from './save_title';

describe('saveTitle', () => {
  beforeEach(() => {
    axios.post.mockClear();
  });

  // 入口の「次へ」（entry_logic.js）と同じ口に揃える
  it('update_title に event_id とタイトルを送る', () => {
    saveTitle(123, 'ガッツリ満腹！二郎系ラーメン交流会');

    expect(axios.post).toHaveBeenCalledWith(
      '/api/event_edit/update_title',
      JSON.stringify({ event_id: 123, title: 'ガッツリ満腹！二郎系ラーメン交流会' })
    );
  });

  it('前後の空白は落として送る', () => {
    saveTitle(123, '  タイトル  ');

    expect(axios.post).toHaveBeenCalledWith(
      '/api/event_edit/update_title',
      JSON.stringify({ event_id: 123, title: 'タイトル' })
    );
  });

  it('タイトルが未定義でも落ちない', () => {
    expect(() => saveTitle(123, undefined)).not.toThrow();
  });
});

// @context TGW-2591 カバー画像の作り直しは Sidekiq で非同期に走る。保存直後はまだ古い画像が返る。
//   タイトルを変えると「タグ無し」→「タグ付き」の2段階で変わるので、そのつど差し替える。
//   利用者にリロードを求めないための仕組み。
describe('watchCoverImage', () => {
  const sleep = () => Promise.resolve(); // テストでは待たない

  it('URLが変わるたびに差し替えを知らせる（タグ無し→タグ付きの2段階）', async () => {
    const fetchUrl = jest
      .fn()
      .mockResolvedValueOnce('https://example.com/old.png')
      .mockResolvedValueOnce('https://example.com/no_tags.png')
      .mockResolvedValue('https://example.com/with_tags.png');
    const onUpdated = jest.fn();

    await watchCoverImage(1, 'タイトル', 'https://example.com/old.png', onUpdated, {
      attempts: 4,
      sleep,
      fetchUrl,
    });

    expect(onUpdated).toHaveBeenNthCalledWith(1, 'https://example.com/no_tags.png');
    expect(onUpdated).toHaveBeenNthCalledWith(2, 'https://example.com/with_tags.png');
    expect(onUpdated).toHaveBeenCalledTimes(2); // 同じURLでは呼ばない
  });

  it('最初の確認は待たずに行う（無駄な待ち時間を作らない）', async () => {
    const order = [];
    const fetchUrl = jest.fn(() => {
      order.push('fetch');
      return Promise.resolve('https://example.com/old.png');
    });
    const sleepSpy = () => {
      order.push('sleep');
      return Promise.resolve();
    };

    await watchCoverImage(1, 'タイトル', 'https://example.com/old.png', jest.fn(), {
      attempts: 1,
      sleep: sleepSpy,
      fetchUrl,
    });

    expect(order[0]).toBe('fetch');
  });

  // 間に合わなくても編集は続けられる。画面は古いままで、リロードすれば新しくなる
  it('作り直しが終わらなければ null を返し、差し替えも知らせない', async () => {
    const fetchUrl = jest.fn().mockResolvedValue('https://example.com/old.png');
    const onUpdated = jest.fn();

    const url = await watchCoverImage(1, 'タイトル', 'https://example.com/old.png', onUpdated, {
      attempts: 3,
      sleep,
      fetchUrl,
    });

    expect(url).toBeNull();
    expect(onUpdated).not.toHaveBeenCalled();
    expect(fetchUrl).toHaveBeenCalledTimes(3);
  });

  it('取得に失敗しても諦めず、次の回で取り直す', async () => {
    const fetchUrl = jest
      .fn()
      .mockRejectedValueOnce(new Error('network'))
      .mockResolvedValue('https://example.com/new.png');
    const onUpdated = jest.fn();

    await watchCoverImage(1, 'タイトル', 'https://example.com/old.png', onUpdated, {
      attempts: 2,
      sleep,
      fetchUrl,
    });

    expect(onUpdated).toHaveBeenCalledWith('https://example.com/new.png');
  });

  it('何度も叩き続けない（上限がある）', async () => {
    const fetchUrl = jest.fn().mockResolvedValue('https://example.com/old.png');

    await watchCoverImage(1, 'タイトル', 'https://example.com/old.png', jest.fn(), {
      sleep,
      fetchUrl,
    });

    expect(fetchUrl).toHaveBeenCalledTimes(14);
  });
});

describe('fetchCoverImageUrl', () => {
  beforeEach(() => {
    axios.post.mockClear();
  });

  // カバー画像が既にあるときは作らずに現在のURLを返すので、取得用として使える
  it('generate_default_image を叩いて main_image_url を返す', async () => {
    axios.post.mockResolvedValue({ data: { main_image_url: 'https://example.com/a.png' } });

    const url = await fetchCoverImageUrl(1, 'タイトル');

    expect(axios.post).toHaveBeenCalledWith(
      '/api/event/generate_default_image',
      JSON.stringify({ event_id: 1, event_title: 'タイトル' })
    );
    expect(url).toBe('https://example.com/a.png');
  });
});
